import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobCardTaskReportNormalLists: {
        isLoading: false,
        isLoadingMore: false,
        dataLoaded: false,
        data: null,
        totalRecords: 0,
        recordCounts: 0,
        pageNo: 1,
        selectedJobCardTaskNo: null,
        perPageRecords: 1000,
        jobCardReportError: ''
    },
}

const jobCardTaskReportSlice = createSlice({
    name: "jobCardTaskReportSlice",
    initialState,
    reducers: {
        jobCardTaskReportNormalLoadingPending: (state) => {
            state.jobCardTaskReportNormalLists.isLoading = true;
            state.jobCardTaskReportNormalLists.dataLoaded = false;
            state.jobCardTaskReportNormalLists.recordCounts = 0;
            state.jobCardTaskReportNormalLists.totalRecords = 0;
        },
        jobCardTaskReportNormalLoadingSuccess: (state, { payload }) => {
            state.jobCardTaskReportNormalLists.isLoading = false;
            state.jobCardTaskReportNormalLists.data = payload.data;
            state.jobCardTaskReportNormalLists.jobCardReportError = '';
            state.jobCardTaskReportNormalLists.dataLoaded = true;
            state.jobCardTaskReportNormalLists.recordCounts = payload.recordCounts;
            state.jobCardTaskReportNormalLists.totalRecords = payload.totalRecords;
        },
        jobCardTaskReportNormalLoadingFailed: (state, { payload }) => {
            state.jobCardTaskReportNormalLists.isLoading = false;
            state.jobCardTaskReportNormalLists.data = []
            state.jobCardTaskReportNormalLists.jobCardReportError = payload;
            state.jobCardTaskReportNormalLists.dataLoaded = true;
        },
        selectJobCardTaskNo: (state, { payload }) => {
            const selectedJobCard = state.jobCardTaskReportNormalLists.data.find((jc) => jc.jobCardId === payload);
            if (selectedJobCard) {
                state.jobCardTaskReportNormalLists.selectedJobCardTaskNo = selectedJobCard;
            }
        },
        jobCardReportNormalListReset: (state) => {
            state.jobCardTaskReportNormalLists.isLoading = false;
            state.jobCardTaskReportNormalLists.isLoadingMore = false;
            state.jobCardTaskReportNormalLists.dataLoaded = false;
            state.jobCardTaskReportNormalLists.data = null;
            state.jobCardTaskReportNormalLists.totalRecords = 0;
            state.jobCardTaskReportNormalLists.recordCounts = 0
            state.jobCardTaskReportNormalLists.pageNo = 1;
            state.jobCardTaskReportNormalLists.selectedJobCardTaskNo = null;
            state.jobCardTaskReportNormalLists.perPageRecords = 1000;
            state.jobCardTaskReportNormalLists.jobCardReportError = '';
            state.jobCardTaskReportNormalLists.jobCardReportError = '';
        },

    }
});

const { reducer, actions } = jobCardTaskReportSlice;

export const {
    jobCardTaskReportNormalLoadingPending, jobCardTaskReportNormalLoadingSuccess, jobCardTaskReportNormalLoadingFailed, selectJobCardTaskNo, jobCardReportNormalListReset
}
    = actions;

export default reducer;